/** @flow */
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { SCard, CardWrapper, CardContent } from 'common/modules/printing/styles/Card';
import GenderGraph from 'common/components/charts/GenderGraph';
import AgeRangeGraph from 'common/components/charts/AgeRangeGraph';

import Images from '../../../themes/Images';
import GenderReach from '../../../domain/GenderReach';
import AgeRangeReaches from '../../../domain/AgeRangeReaches';
import { GraphTitle, GraphWrapper, ErrorMessageWrapper } from '../styles/Graph';

const Wrapper = styled(SCard)`
  height: 328px;
`;

const CardTitle = styled.div`
  text-align: left;
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 16px;
  font-weight: bold;
`;

const PlaceHolderImage = styled.img`
  margin: ${({ theme }) => theme.metrics.margin}px 0px;
  height: 175px;
`;

const SGraphWrapper = styled(GraphWrapper)`
  height: 280px;
  width: 300px;
`;

type Props = {
  genderDemography: ?GenderReach;
  ageGroup: ?AgeRangeReaches;
  title: ?string;

  t: any,
  theme: any,
};

class SalesPrintingDemography extends React.Component<Props> {
  renderAgeRangeGraph = () => {
    const { t, ageGroup } = this.props;

    if (!ageGroup || ageGroup.isEmpty()) {
      return (
        <React.Fragment>
          <PlaceHolderImage src={Images.emptyAgeRange} alt={t('cannotRenderImage')} />
          <ErrorMessageWrapper>{t('notEnoughData')}</ErrorMessageWrapper>
        </React.Fragment>
      );
    }

    return <AgeRangeGraph data={ageGroup} commercialAgeGroupPlacement={'bottom'} showMissingDataLegend animate={false} showLabels hideInterpolated />;
  };

  renderGenderGraph = () => {
    const { t, theme, genderDemography } = this.props;

    if (!genderDemography || genderDemography.isEmpty()) {
      return (
        <React.Fragment>
          <PlaceHolderImage src={Images.emptyDemo} alt={t('cannotRenderImage')} />
          <ErrorMessageWrapper>{t('notEnoughData')}</ErrorMessageWrapper>
        </React.Fragment>
      );
    }

    return <GenderGraph data={genderDemography} legendPosition={'bottom'} animate={false} fontSize={theme.fonts.style.midSmall.fontSize} />;
  };

  render() {
    const { t } = this.props;

    return (
      <Wrapper>
        <CardWrapper>
          {this.props.title &&
            <CardTitle>
              {this.props.title}
            </CardTitle>}
          <CardContent>
            <SGraphWrapper flex={3}>
              <GraphTitle>
                {t('ageRange')}
              </GraphTitle>
              {this.renderAgeRangeGraph()}
            </SGraphWrapper>
            <SGraphWrapper>
              <GraphTitle>
                {t('gender.name')}
              </GraphTitle>
              {this.renderGenderGraph()}
            </SGraphWrapper>
          </CardContent>
        </CardWrapper>
      </Wrapper>
    );
  }
}

export default translate('demography')(withTheme(SalesPrintingDemography));



// WEBPACK FOOTER //
// ./src/common/modules/printing/components/DemographyCard.js